import React from "react";
import FormikWrapper from "../FormikWrapper";
import { newPasswordSchema } from "../../formValidation";
import Loader from "../Loader";
import SvgIcon from "../../assets/icons/SvgIcon";
import Password from "../Password";

interface ResetPasswordFormProps {
  handleOnSubmit: (values: any) => void;
  btnLoader: boolean;
}

const ResetPasswordForm: React.FC<ResetPasswordFormProps> = ({
  handleOnSubmit,
  btnLoader,
}) => {
  const initialValues = {
    password: "",
    confirmPassword: "",
  };

  return (
    <div className="w-full">
      <SvgIcon iconName="savitar-realty-logo" className="w-60 h-auto mx-auto" />
      <div className="w-full p-6 flex flex-col justify-between">
        <h5 className="text-center font-semibold text-xl leading-6 mb-10">
          Set New Password
        </h5>
        <FormikWrapper
          initialValues={initialValues}
          validationSchema={newPasswordSchema}
          onSubmit={handleOnSubmit}
          buttonProps={{
            children: btnLoader ? (
              <Loader size="small" />
            ) : (
              <>
                <SvgIcon iconName="sign-out" className="mr-2" /> Submit
              </>
            ),
            className: "w-full mt-10",
            isDisabled: btnLoader,
          }}
        >
          <div className="space-y-6">
            <Password
              label="New Password"
              name="password"
              required
              placeholder="Enter your new password"
            />
            <Password
              label="Confirm Password"
              name="confirmPassword"
              required
              placeholder="Enter your confirm password"
            />
          </div>
        </FormikWrapper>
      </div>
    </div>
  );
};

export default ResetPasswordForm;
